<div id="map-branch" class="skeleton-animation" style=" position: relative;">
  <div class="loader-animations">
    <span class="loaders-skeleton"> </span>

  </div>
</div>
